import {Link, useLocation} from "react-router-dom";
import React from "react";
import {RoleInfo} from "../../utils/auth";
import {UserAuthItemTypeEnum} from "arteco-api-client-ts";
import {useAuthManager} from "../../utils/auth";
import {COLOR_VERDE_ARTECO} from "../colors";
import {MenuItem} from "@mui/material";


export interface NavbarItemProps {
    map: Map<UserAuthItemTypeEnum, RoleInfo>,
    role: UserAuthItemTypeEnum,
    /** Como opción de un menú desplegable (móvil, #13825) en vez de enlace de la barra. */
    asMenuItem?: boolean,
    onSelect?: () => void,
}

const NavbarItem = ({role, map, asMenuItem, onSelect}: NavbarItemProps) => {
    const location = useLocation();
    const authManager = useAuthManager();

    const roleInfo = map.get(role);
    const roleInfo_target = roleInfo?.target || "";
    const roleInfo_title = roleInfo?.title || "";
    const roleInfo_admin = roleInfo?.isAdmin || false;

    const userAdminRole = authManager.getAuthorities().find(a => a.type === UserAuthItemTypeEnum.ADMIN);
    const userReqRole = authManager.getAuthorities().find(a => a.type === role);

    const showRoleInfo = userReqRole || (roleInfo_admin && !!userAdminRole);
    const mark = location.pathname.startsWith(roleInfo_target);
    const auth = userReqRole || userAdminRole;

    const select = () => {
        auth && authManager.saveSelectedAuthority(auth);
        onSelect && onSelect();
    };

    if (asMenuItem) {
        return showRoleInfo ? (
            <MenuItem component={Link} to={roleInfo_target} onClick={select} selected={mark}
                      sx={{color: mark ? COLOR_VERDE_ARTECO.toString() : undefined}}>
                {roleInfo_title}
            </MenuItem>
        ) : null;
    }

    return (
        <>
            {showRoleInfo && (
                <Link style={{
                    marginRight: "1em",
                    textDecoration: "none",
                    color: mark ? COLOR_VERDE_ARTECO.toString() : "white",
                }}
                      onClick={select}
                      to={roleInfo_target}>{roleInfo_title}</Link>
            )}
        </>
    )
}

export default NavbarItem;